/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Cold_Fancy_Turtle_SpinInputs */

const en_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Start using your premium purchase on this device`);
	return /** @type {LocalizedString} */ (`Start using your premium subscription on this device`)
	
};

const id_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mulai gunakan pembelian premium Anda di device ini`);
	return /** @type {LocalizedString} */ (`Mulai menggunakan langganan premium Anda di perangkat ini`)
	
};

const ms_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mula menggunakan pembelian premium anda pada peranti ini`);
	return /** @type {LocalizedString} */ (`Mula menggunakan langganan premium anda pada peranti ini`)
	
};

const ca_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Comença a fer servir la teva compra premium en aquest aparell`);
	return /** @type {LocalizedString} */ (`Comença a utilitzar la teva subscripció premium en aquest dispositiu.`)
	
};

const cs_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Začněte používat svůj premium nákup na tomto zařízení`);
	return /** @type {LocalizedString} */ (`Začněte používat svoje prémiové předplatné na tomto zařízení`)
	
};

const da_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Begynd at bruge dit premium-køb på denne enhed`);
	return /** @type {LocalizedString} */ (`Begynd at bruge dit premium-abonnement på denne enhed`)
	
};

const de_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Verwenden Sie Ihren Premium-Kauf auf diesem Gerät`);
	return /** @type {LocalizedString} */ (`Verwenden Sie Ihr Premium-Abonnement auf diesem Gerät`)
	
};

const et_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Alusta oma premium-ostu kasutamist sellel seadmel`);
	return /** @type {LocalizedString} */ (`Alustage oma premium tellimuse kasutamist selles seadmes`)
	
};

const es_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Comienza a usar tu compra premium en este dispositivo`);
	return /** @type {LocalizedString} */ (`Comienza a usar tu suscripción premium en este dispositivo`)
	
};

const fr_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Commencez à utiliser votre achat premium sur cet appareil`);
	return /** @type {LocalizedString} */ (`Commencez à utiliser votre abonnement Premium sur cet appareil.`)
	
};

const hr_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Počnite koristiti svoju premium kupnju na ovom uređaju`);
	return /** @type {LocalizedString} */ (`Počnite koristiti svoju premium pretplatu na ovom uređaju.`)
	
};

const it_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Inizia a usare il tuo acquisto Premium su questo dispositivo`);
	return /** @type {LocalizedString} */ (`Inizia a usare il tuo abbonamento premium su questo dispositivo`)
	
};

const lv_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Sāciet izmantot savu premium pirkumu šajā ierīcē`);
	return /** @type {LocalizedString} */ (`Sāciet izmantot savu premium abonementu šajā ierīcē.`)
	
};

const lt_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pradėkite naudoti savo premium pirkinį šiame įrenginyje`);
	return /** @type {LocalizedString} */ (`Pradėkite naudoti savo premium prenumeratą šiame įrenginyje`)
	
};

const hu_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kezdd el használni a prémium vásárlásodat ezen az eszközön`);
	return /** @type {LocalizedString} */ (`Kezdje használni a prémium előfizetését ezen az eszközön`)
	
};

const nl_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Begin je premium aankoop te gebruiken op dit device`);
	return /** @type {LocalizedString} */ (`Begin met het gebruik van je premium abonnement op dit apparaat`)
	
};

const nb_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Begynn å bruke ditt premium-kjøp på denne enheten`);
	return /** @type {LocalizedString} */ (`Begynn å bruke Premium-abonnementet ditt på denne enheten`)
	
};

const pl_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zacznij używać zakupu premium na tym urządzeniu`);
	return /** @type {LocalizedString} */ (`Rozpocznij korzystanie ze swojej subskrypcji premium na tym urządzeniu`)
	
};

const pt_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Comece a usar sua compra premium neste dispositivo`);
	return /** @type {LocalizedString} */ (`Comece a usar sua assinatura premium neste dispositivo.`)
	
};

const ro_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Începe să folosești achiziția ta premium pe acest dispozitiv`);
	return /** @type {LocalizedString} */ (`Începeți să utilizați abonamentul dvs. premium pe acest dispozitiv`)
	
};

const sk_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Začnite používať váš premium nákup na tomto zariadení`);
	return /** @type {LocalizedString} */ (`Začnite používať svoje prémiové predplatné na tomto zariadení`)
	
};

const sl_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Začnite uporabljati svoj premium nakup na tej napravi`);
	return /** @type {LocalizedString} */ (`Začnite uporabljati svojo premium naročnino na tej napravi`)
	
};

const fi_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Aloita premium-ostoksesi käyttäminen tällä laitteella`);
	return /** @type {LocalizedString} */ (`Aloita premium-tilauksesi käyttö tässä laitteessa.`)
	
};

const sv_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Börja använda ditt premium-köp på den här enheten`);
	return /** @type {LocalizedString} */ (`Börja använda din premiumprenumeration på denna enhet`)
	
};

const vi_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Bắt đầu sử dụng mua hàng Premium của bạn trên thiết bị này`);
	return /** @type {LocalizedString} */ (`Bắt đầu sử dụng gói đăng ký cao cấp của bạn trên thiết bị này`)
	
};

const tr_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Premium satın almanızı bu cihazda kullanmaya başlayın`);
	return /** @type {LocalizedString} */ (`Bu cihazda premium aboneliğinizi kullanmaya başlayın`)
	
};

const el_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ξεκινήστε τη χρήση της premium αγοράς σας σε αυτή τη συσκευή`);
	return /** @type {LocalizedString} */ (`Ξεκινήστε να χρησιμοποιείτε τη premium συνδρομή σας σε αυτήν τη συσκευή`)
	
};

const bg_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Започнете да използвате premium покупката си на това устройство`);
	return /** @type {LocalizedString} */ (`Започнете да използвате своя премиум абонамент на това устройство.`)
	
};

const ru_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Начните использовать свою Премиум покупку на этом устройстве`);
	return /** @type {LocalizedString} */ (`Начните использовать вашу премиальную подписку на этом устройстве.`)
	
};

const sr_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Започните коришћење ваше premium куповине на овом уређају`);
	return /** @type {LocalizedString} */ (`Почните користити своју премиум претплату на овом уређају`)
	
};

const uk_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Почніть користуватися своєю purchase Premium на цьому пристрої`);
	return /** @type {LocalizedString} */ (`Почніть користуватися вашою преміум-підпискою на цьому пристрої`)
	
};

const ka_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`დაიწყეთ თქვენი premium შეძენის გამოყენება ამ მოწყობილობაზე`);
	return /** @type {LocalizedString} */ (`დაიწყეთ პრემიალური გამოწერის გამოყენება ამ მოწყობილობაზე.`)
	
};

const hi_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`इस डिवाइस पर अपनी प्रीमियम खरीद का उपयोग शुरू करें`);
	return /** @type {LocalizedString} */ (`इस डिवाइस पर अपनी प्रीमियम सदस्यता का उपयोग शुरू करें`)
	
};

const th_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`เริ่มใช้การซื้อ Premium ของคุณบนอุปกรณ์เครื่องนี้`);
	return /** @type {LocalizedString} */ (`เริ่มใช้การสมัครพรีเมี่ยมของคุณบนอุปกรณ์นี้`)
	
};

const ko_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`이 디바이스에서 프리미엄 구매 사용 시작`);
	return /** @type {LocalizedString} */ (`이 장치에서 프리미엄 구독을 사용하기 시작하세요`)
	
};

const zh_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`开始在此设备上使用您的高级订阅`)
};

const zh_tw_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`開始在此裝置上使用您的高級版購買內容`);
	return /** @type {LocalizedString} */ (`開始在此裝置上使用您的高級版訂閱服務`)
	
};

const ja_cold_fancy_turtle_spin = /** @type {(inputs: Cold_Fancy_Turtle_SpinInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`このデバイスでプレミアム購入を使い始める`);
	return /** @type {LocalizedString} */ (`このデバイスでプレミアムプランのサブスクリプションを開始`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "Start using your premium purchase on this device" |
* | * | "Start using your premium subscription on this device" |
*
* @param {Cold_Fancy_Turtle_SpinInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const cold_fancy_turtle_spin = /** @type {((inputs: Cold_Fancy_Turtle_SpinInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cold_Fancy_Turtle_SpinInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cold_fancy_turtle_spin(inputs)
	if (locale === "ms") return ms_cold_fancy_turtle_spin(inputs)
	if (locale === "ca") return ca_cold_fancy_turtle_spin(inputs)
	if (locale === "cs") return cs_cold_fancy_turtle_spin(inputs)
	if (locale === "da") return da_cold_fancy_turtle_spin(inputs)
	if (locale === "de") return de_cold_fancy_turtle_spin(inputs)
	if (locale === "et") return et_cold_fancy_turtle_spin(inputs)
	if (locale === "es") return es_cold_fancy_turtle_spin(inputs)
	if (locale === "fr") return fr_cold_fancy_turtle_spin(inputs)
	if (locale === "hr") return hr_cold_fancy_turtle_spin(inputs)
	if (locale === "it") return it_cold_fancy_turtle_spin(inputs)
	if (locale === "lv") return lv_cold_fancy_turtle_spin(inputs)
	if (locale === "lt") return lt_cold_fancy_turtle_spin(inputs)
	if (locale === "hu") return hu_cold_fancy_turtle_spin(inputs)
	if (locale === "nl") return nl_cold_fancy_turtle_spin(inputs)
	if (locale === "nb") return nb_cold_fancy_turtle_spin(inputs)
	if (locale === "pl") return pl_cold_fancy_turtle_spin(inputs)
	if (locale === "pt") return pt_cold_fancy_turtle_spin(inputs)
	if (locale === "ro") return ro_cold_fancy_turtle_spin(inputs)
	if (locale === "sk") return sk_cold_fancy_turtle_spin(inputs)
	if (locale === "sl") return sl_cold_fancy_turtle_spin(inputs)
	if (locale === "fi") return fi_cold_fancy_turtle_spin(inputs)
	if (locale === "sv") return sv_cold_fancy_turtle_spin(inputs)
	if (locale === "vi") return vi_cold_fancy_turtle_spin(inputs)
	if (locale === "tr") return tr_cold_fancy_turtle_spin(inputs)
	if (locale === "el") return el_cold_fancy_turtle_spin(inputs)
	if (locale === "bg") return bg_cold_fancy_turtle_spin(inputs)
	if (locale === "ru") return ru_cold_fancy_turtle_spin(inputs)
	if (locale === "sr") return sr_cold_fancy_turtle_spin(inputs)
	if (locale === "uk") return uk_cold_fancy_turtle_spin(inputs)
	if (locale === "ka") return ka_cold_fancy_turtle_spin(inputs)
	if (locale === "hi") return hi_cold_fancy_turtle_spin(inputs)
	if (locale === "th") return th_cold_fancy_turtle_spin(inputs)
	if (locale === "ko") return ko_cold_fancy_turtle_spin(inputs)
	if (locale === "zh") return zh_cold_fancy_turtle_spin(inputs)
	if (locale === "zh-tw") return zh_tw_cold_fancy_turtle_spin(inputs)
	if (locale === "ja") return ja_cold_fancy_turtle_spin(inputs)
	return en_cold_fancy_turtle_spin(inputs)
});